/**
 * Validate a "next"/redirect path to prevent open-redirect XSS.
 * Only same-origin, path-only redirects are allowed.
 * Returns the safe path, or the fallback if input is unsafe.
 */
export function safeRedirect(input: string | null | undefined, fallback = "/wallet"): string {
  if (!input || typeof input !== "string") return fallback;
  let value = input.trim();
  if (!value) return fallback;

  // Reject javascript:, data:, vbscript:, etc.
  if (/^[a-z][a-z0-9+.-]*:/i.test(value)) return fallback;

  // Reject protocol-relative URLs (//evil.com) and backslash variants (/\evil.com)
  if (value.startsWith("//") || value.startsWith("/\\") || value.startsWith("\\")) return fallback;

  // Must be a root-relative path
  if (!value.startsWith("/")) return fallback;

  // Strip any embedded CR/LF that could break headers
  if (/[\r\n\t]/.test(value)) return fallback;

  // Optionally validate it parses as a same-origin URL
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}
